export const propsToModel = (props, model, validProps = []) =>
{
  Object.entries(props).forEach(([key, value]) =>
  {
    const isValidProp = validProps.length === 0 ? true : validProps.includes(key);

    if(model.hasOwnProperty(key) && isValidProp)
      model[key] = value;
  })
}